import { MutationResult } from "@apollo/client"

export type BatchBlockType = {
  documentID?: string
  documentRevisionID?: string | null
  blockRevision?: number
  documentScope?: "source" | "effective"
  draft?: boolean
  order?: number
  layout?: string
  type?: string
  id: string
  data?: Record<string, any>
  style?: Record<string, any>
  scope?: string
  trackProgress?: boolean
  userID?: string
  clientVersion?: number
  callback?: ((result: MutationResult) => void) | null
}

export type BlockBatchType = {
  [key: string]: BatchBlockType
}

// store batch of unsaved block edits
export const initBatch = (): BlockBatchType => {
  let batch: BlockBatchType = {}

  return batch
}
